const ConversationImportTutorialModel = {
    type: 'panel',
    name: 'providerTutorial',
    blocks: [
		{
			name: 'introduction',
			type: 'mixed',
			max: 1,
			blocks: [
				{
					name: 'text',
					max: 1,
					type: 'html',
				},
				{
					name: 'image',
					max: 1,
					type: 'image',
				},
			],
		},
		{
			name: 'selection',
			type: 'mixed',
			max: 1,
			blocks: [
				{
					name: 'text',
					max: 1,
					type: 'html',
				},
				{
					name: 'links',
					type: 'mixed',
					blocks: [
						{
							name: 'image',
							max: 1,
							type: 'image',
						},
						{
							name: 'variation-link',
							max: 1,
							type: 'link',
						},
					],
				},
			],
		},
		{
			name: 'variations',
			type: 'mixed',
			blocks: [
				{
					name: 'identifier',
					max: 1,
					type: 'text',
				},
				{
					name: 'steps',
					type: 'mixed',
					blocks: [
						{
							name: 'text',
							max: 1,
							type: 'html',
						},
						{
							name: 'image',
							max: 1,
							type: 'image',
						},
					]
				}
			],
		},
	],
};

export default ConversationImportTutorialModel;
